
import {ACTIONS} from "./SectionDataReducer";

export function AddCheckboxNumber (section, dispatch, subSection, value, key, answers, questions, baseKey, pageType) {
    //console.log(questions[baseKey]);
    if(questions[baseKey].typeCode=="CHECKBOX_NUMBER"){
        if(value == "C012" || value == "C199"){
            if(answers.hasOwnProperty(baseKey+"txt") || answers.hasOwnProperty(baseKey+value+"number")){
                //console.log(key+value+"number");
                //console.log(answers[key+"txt"])
                dispatch({
                    type: ACTIONS.UPDATE_ANSWER,
                    //questionId: question.id,
                    questionCode: baseKey,//question.questionCode,
                    subSection: subSection,
                    answerCode: value,
                    checked: true,
                    value: {
                        text: answers.hasOwnProperty(baseKey+"txt") == true ? answers[baseKey+"txt"] : "",
                        number : answers.hasOwnProperty(baseKey+value+"number") == true ? answers[baseKey+value+"number"] : ""
                    }, 
                    isInvalid: false,
                    errors:[],
                    pageType: pageType,
                    //visible: true
                }); 
            }
            else{
                if(answers.hasOwnProperty(baseKey)){
                    
                    dispatch({
                        type: ACTIONS.UPDATE_ANSWER,
                        //questionId: question.id,
                        questionCode: baseKey,//question.questionCode,
                        subSection: subSection,
                        answerCode: value,
                        checked: true,
                        value: {
                            text: "",
                            number : ""
                        }, 
                        isInvalid: false,
                        errors:[],
                        pageType: pageType,
                        //visible: true
                    }); 
                }
            }

            
            
        }
        else{
            if(answers.hasOwnProperty(baseKey+value+"txt")){
                dispatch({
                    type: ACTIONS.UPDATE_ANSWER,
                    //questionId: question.id,
                    questionCode: baseKey,//question.questionCode,
                    subSection: subSection,
                    answerCode: value,
                    checked: true,
                    value: answers[baseKey+value+"txt"],
                    
                    isInvalid: false,
                    errors:[],
                    pageType: pageType,
                    //visible: true
                }); 
            }
            /*else {
                dispatch({
                    type: ACTIONS.UPDATE_ANSWER,
                    //questionId: question.id,
                    questionCode: key,//question.questionCode,
                    subSection: subSection,
                    answerCode: value,
                    checked: true,
                    value: '',
                    
                    isInvalid: false,
                    errors:[]
                }); 
            }*/
            if(answers.hasOwnProperty(baseKey+value+"number")){
                //console.log("HOSPITAL");
                //console.log(baseKey);
                //console.log(value);
                if(answers.hasOwnProperty(baseKey+value+"number") == true){
                    dispatch({
                        type: ACTIONS.UPDATE_ANSWER,
                        //questionId: question.id,
                        questionCode: baseKey,//question.questionCode,
                        subSection: subSection,
                        answerCode: value,
                        checked: true,
                        value: answers.hasOwnProperty(baseKey+value+"number") == true ? answers[baseKey+value+"number"] : "", //answers[key+"txt"],
                        //visible: true,//!answerDisplayConditions(answerCode,e)
                        isInvalid: false,
                        errors:[],
                        pageType: pageType,
                        //visible: true
                    }); 
                }
                
            }
            else{
                dispatch({
                    type: ACTIONS.UPDATE_ANSWER,
                    //questionId: question.id,
                    questionCode: baseKey,//question.questionCode,
                    subSection: subSection,
                    answerCode: value,
                    checked: true,
                    //value: answers.hasOwnProperty(baseKey+value+"number") == true ? answers[baseKey+value+"number"] : "", //answers[key+"txt"],
                    //visible: true,//!answerDisplayConditions(answerCode,e)
                    isInvalid: false,
                    errors:[],
                    pageType: pageType,
                    //visible: true
                }); 
            }


        }
    }
    else{
        var noContent = true;
        if(answers.hasOwnProperty(baseKey+"txt")){
            noContent = false;
            dispatch({
                type: ACTIONS.UPDATE_ANSWER,
                //questionId: question.id,
                questionCode: baseKey,//question.questionCode,
                subSection: subSection,
                answerCode: value,
                checked: true,
                value: answers[baseKey+"txt"],
                
                isInvalid: false,
                errors:[],
                pageType: pageType,
                //visible: true
            }); 
        }
        
           
       
        if(answers.hasOwnProperty(baseKey+value+"number")){
            noContent = false;
            dispatch({
                type: ACTIONS.UPDATE_ANSWER,
                //questionId: question.id,
                questionCode: baseKey,//question.questionCode,
                subSection: subSection,
                answerCode: value,
                checked: true,
                value: answers.hasOwnProperty(baseKey+value+"number") == true ? answers[baseKey+value+"number"] : "", //answers[key+"txt"],
                //visible: true,//!answerDisplayConditions(answerCode,e)
                isInvalid: false,
                errors:[],
                pageType: pageType,
                //visible: true
            }); 
        }

        if(noContent==true){
            //console.log(value);
            dispatch({
                type: ACTIONS.UPDATE_ANSWER,
                //questionId: question.id,
                questionCode: baseKey,//question.questionCode,
                subSection: subSection,
                answerCode: value,
                checked: true,
                value: '',
                //visible: true,
                isInvalid: false,
                errors:[],
                pageType: pageType
            }); 
        }
    }
   
}


export function AddRadioChk (section, dispatch, subSection, value, key, answers, questions, baseKey, pageType) {
    //console.log(questions[baseKey]);
    //console.log(value);

        dispatch({
            type: ACTIONS.UPDATE_ANSWER,
            //questionId: question.id,
            questionCode: baseKey,//question.questionCode,
            subSection: subSection,
            answerCode: value,
            checked: true,
            //value: answers[key],
            //visible: true,//!answerDisplayConditions(answerCode,e)
            isInvalid: false,
            errors:[],
            pageType: pageType
        }); 

        //console.log(section);
   
}